import {
  Component,
  forwardRef,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ContactPickerConfigurationService } from '$core/services/contact-picker-configuration.service';
import { BelpostContact } from '$shared/types/belpost-contact';
import { AddressWidgetPickerConfigType } from '$shared/components/address-widget-picker/model/address-widget-picker-config-type';
import { AddressWidgetPickerEvent } from '$shared/components/address-widget-picker/model/address-widget-picker-event';
import { WidgetToBelpostAdapterService } from '$shared/components/address-widget-picker/services/widget-belpost-contact-adapter.service';
import { BelpostToWidgetUserAdapter } from '$shared/components/address-widget-picker/services/belpost-contact-widget-adapter.service';

@Component({
  selector: 'app-address-widget-picker',
  templateUrl: './address-widget-picker.component.html',
  styleUrls: ['./address-widget-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressWidgetPickerComponent),
      multi: true,
    },
    ContactPickerConfigurationService,
  ],
})
export class AddressWidgetPickerComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() public readonly widgetConfig: AddressWidgetPickerConfigType;

  public readonly configuration$ =
    this.contactPickerConfiguration.configuration$;

  constructor(
    private readonly contactPickerConfiguration: ContactPickerConfigurationService,
    private readonly widgetToBelpostAdapterService: WidgetToBelpostAdapterService,
    private readonly belpostToWidgetUserAdapter: BelpostToWidgetUserAdapter
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['widgetConfig']) {
      this.contactPickerConfiguration.setWidgetConfig(this.widgetConfig);
    }
  }

  public ngOnInit(): void {
    this.contactPickerConfiguration.setWidgetConfig(this.widgetConfig);
  }

  public onValueChange(widgetEvent: AddressWidgetPickerEvent): void {
    if (!widgetEvent.detail) {
      this.onChange(null);

      return;
    }

    try {
      const belpostContact = this.widgetToBelpostAdapterService.transform(
        widgetEvent.detail
      );

      this.onChange(belpostContact);
      this.onTouched();
      this.writeValue(belpostContact);
    } catch (error) {
      console.error('Error transforming contact:', error);
      this.onChange(null);
    }
  }

  private onChange: (value: BelpostContact | null) => void = () => {};
  private onTouched: () => void = () => {};

  public writeValue(belpostContact: BelpostContact | null): void {
    const widgetValue =
      this.belpostToWidgetUserAdapter.transform(belpostContact);

    this.contactPickerConfiguration.setWidgetValue(widgetValue);
  }

  public registerOnChange(fn: (value: BelpostContact | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.contactPickerConfiguration.setIsDisabled(isDisabled);
  }
}
